import { render } from "./Help.vue?vue&type=template&id=d84ae420"
import script from "./Help.vue?vue&type=script&lang=ts"
export * from "./Help.vue?vue&type=script&lang=ts"
script.render = render

export default script